export default __webpack_public_path__ + "static/media/graph-blue.583675cd.svg";